import { Cutout, FaceBand } from '../../cutting-panel-outline.model';
import {
  CountertopAngleProcessingBase,
  CountertopEdgeBanding,
  CountertopFastenersSet,
  CountertopHole,
  CountertopOutline,
  CountertopSlot,
} from '../outline';

export const simpleCountertopAngles = ['1', '2', '3', '4'] as const;
export type SimpleCountertopAngle = typeof simpleCountertopAngles[number];
export type SimpleCountertopAngleData<T> = Record<SimpleCountertopAngle, T>;

export const simpleCountertopSides = ['1', '2', '3', '4'] as const;
export type SimpleCountertopSide = typeof simpleCountertopSides[number];
export type SimpleCountertopSideData<T> = Record<SimpleCountertopSide, T>;

export class SimpleCountertopOutline implements CountertopOutline {
  customHoles: CountertopHole[] = [];
  fastenersSets: CountertopFastenersSet[] = [];
  angleProcessing: SimpleCountertopAngleData<CountertopAngleProcessingBase | null> = {
    1: null,
    2: null,
    3: null,
    4: null,
  };
  slots: SimpleCountertopSideData<CountertopSlot[]> = {
    1: [],
    2: [],
    3: [],
    4: [],
  };
  edgeBanding: SimpleCountertopSideData<CountertopEdgeBanding | null> = { 1: null, 2: null, 3: null, 4: null };
  faceBanding: FaceBand[] = [];
  cutouts: Cutout[] = [];
}
